import { UserInterface } from '@e3labs/isa-data-dictionary';
import { AxiosResponse } from 'axios';
import api from '~/services/api';

class BonificationProductService {
  getBonificationProductList({ skip = 0, limit = 30, ...rest }, opts: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/sales-restriction-group', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getListCount({ skip = 0, limit = 30, ...rest }, opts: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/sales-restriction-group', {
      params: {
        skip,
        limit,
        isCount: true,
        ...rest
      },
      ...opts
    });
  }

  getByIdBonificationProduct(id: string, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get(`/sales-restriction-group/${id}`, {
      ...opts
    });
  }

  deleteBonificationProduct(id: string): Promise<AxiosResponse<any[] | null>> {
    return api.delete(`/sales-restriction-group/${id}`);
  }

  saveBonificationProduct(data: any): Promise<AxiosResponse<any[] | null>> {
    return api.post('/sales-restriction-group', {
      ...data
    });
  }

  editBonificationProduct({ id, data }: { id: string; data: any }): Promise<AxiosResponse<any[] | null>> {
    return api.put(`/sales-restriction-group/${id}`, {
      ...data
    });
  }

  getSellers({
    queryString,
    userExternalCodes
  }: {
    queryString?: string;
    userExternalCodes?: string;
  }): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {
        queryString,
        userExternalCodes
      }
    });
  }
}

export default new BonificationProductService();
